(() => {
  if (customElements.get('r1-gallery-video')) return;
  class R1GalleryVideo extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === '1') return;
      this.dataset.ready = '1';
      this.trigger = this.querySelector('[data-video-play]');
      this.player = this.querySelector('[data-video-player]');
      this.template = this.querySelector('[data-video-template]');
      if (!this.trigger || !this.player || !this.template) return;
      this.trigger.addEventListener('click', () => this.play());
      document.documentElement.classList.add('r1-gallery-videos-enabled');
    }
    play() {
      document.querySelectorAll('r1-gallery-video').forEach(item => { if (item !== this) item.pause(); });
      if (!this.player.firstElementChild) this.player.append(this.template.content.cloneNode(true));
      this.trigger.hidden = true;
      this.player.hidden = false;
      const video = this.player.querySelector('video');
      if (video) { video.focus(); video.play().catch(() => {}); }
      else this.player.querySelector('iframe')?.focus();
    }
    pause() {
      if (!this.player) return;
      this.player.querySelector('video')?.pause();
      if (this.player.querySelector('iframe')) {
        this.player.replaceChildren();
        this.player.hidden = true;
        this.trigger.hidden = false;
      }
    }
  }
  customElements.define('r1-gallery-video', R1GalleryVideo);
  const pauseAll = () => document.querySelectorAll('r1-gallery-video').forEach(item => item.pause());
  document.addEventListener('visibilitychange', () => { if (document.hidden) pauseAll(); });
  window.matchMedia('(max-width: 768px)').addEventListener('change', pauseAll);
})();
